import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=f1986b64&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=js&"
export * from "./ReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=f1986b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1986b64",
  null
  
)

export default component.exports